export class BlockNotFoundException extends Error {}
